import React from 'react';
import SmartFormFields from './SmartFormFields';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function EditFormPage({ formId }: { formId: number }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SmartFormFields formId={formId} />
    </QueryClientProvider>
  );
}
